import { render, staticRenderFns } from "./DialogSolicitarRetirada.vue?vue&type=template&id=2bb6f936&"
import script from "./DialogSolicitarRetirada.vue?vue&type=script&lang=js&"
export * from "./DialogSolicitarRetirada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports